module.exports = __webpack_public_path__ + "static/media/chanel_rsvp_banner_mobile.113f94d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chanel_rsvp_banner_mobile.jpg
// module id = 367
// module chunks = 0